import { render, staticRenderFns } from "./SystemConfigurationItem.vue?vue&type=template&id=540e6bfe&"
import script from "./SystemConfigurationItem.vue?vue&type=script&lang=js&"
export * from "./SystemConfigurationItem.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigurationItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports